@if (message?.content | record: message.createdAt | async; as text) {
  <div
    class="py-1 px-5 rounded-2xl bg-black/10 text-sm"
    [matTooltip]="message.createdAt | moment: 'YYYY/MM/DD HH:mm:ss'"
    [attr.data-testid]="'announcement-message'"
  >
    <span [attr.data-testid]="'announcement-message-text'">{{ text }}</span>
  </div>
}
